import { Button } from './button.js';
import { Menu } from './menu.js';

const SelectMenu = {
  baseStyle: {
    button: { ...Button.baseStyle },
    list: {
      ...Menu.baseStyle.list,
      // For the select menu component (composed with ark-ui), there are two items that get the `data-highlighted` attribute, a div and a child span.
      // This ensures that only the subsequent element with `data-highlighted` is selected.
      "[data-highlighted]:not(span)": {
        background: "rgba(0, 0, 0, 0.075)"
      },
      _dark: {
        border: "1px solid",
        borderColor: "rgba(255, 255, 255, 0.125)",
        background: "grayscale.950",
        "[data-highlighted]:not(span)": {
          background: "rgba(255, 255, 255, 0.125)"
        }
      }
    },
    item: {
      ...Menu.baseStyle.item
    },
    groupTitle: {
      fontSize: "header-sm",
      fontWeight: "bold",
      padding: "0.5rem 1rem"
    },
    divider: {
      color: "rgba(0, 0, 0, 0.25)",
      _dark: {
        color: "rgba(255, 255, 255, 0.25)"
      }
    }
  },
  sizes: {
    xs: {
      groupTitle: {
        fontSize: "header-xs"
      },
      item: {
        fontSize: "text-xs"
      }
    },
    sm: {
      groupTitle: {
        fontSize: "header-sm"
      },
      item: {
        fontSize: "text-sm"
      }
    },
    md: {
      groupTitle: {
        fontSize: "header-md"
      },
      item: {
        fontSize: "text-md"
      }
    },
    lg: {
      groupTitle: {
        fontSize: "header-lg"
      },
      item: {
        fontSize: "text-lg"
      }
    }
  },
  variants: {
    // variant for SelectMenu
    withCheck: {
      item: {
        display: "flex",
        // Ensures text in the select menu is left aligned
        'span[data-scope="select"][data-part="item-text"]': {
          flex: "1"
        },
        // Applies check icon to selected (checked) items in a select menu
        '&[role="option"][data-state="checked"]': {
          _after: {
            // Fill of this svg is text-primary
            content: `url("data:image/svg+xml;utf8,<svg viewBox='0 0 24 24' height='20px' width='20px' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M20.706 5.292a1 1 0 0 1 .002 1.414l-10.978 11a1 1 0 0 1-1.415 0l-5.023-5.033a1 1 0 0 1 1.416-1.413l4.314 4.325 10.27-10.291a1 1 0 0 1 1.414-.002Z' fill='rgba(17,25,29,1)'/></svg>")`
          },
          _dark: {
            _after: {
              content: `url("data:image/svg+xml;utf8,<svg viewBox='0 0 24 24' height='20px' widht='20px' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M20.706 5.292a1 1 0 0 1 .002 1.414l-10.978 11a1 1 0 0 1-1.415 0l-5.023-5.033a1 1 0 0 1 1.416-1.413l4.314 4.325 10.27-10.291a1 1 0 0 1 1.414-.002Z' fill='rgba(255,255,255,1)'/></svg>")`
            }
          }
        }
      }
    }
  }
};

export { SelectMenu };
